<script>
export default {
  props:{
    data: {
      type: Array,
    }
  },
  data() {
    return {
      // table
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 5,
      countries: this.data.filter((x)=>x.total > 0),
      perPageOptions: [5, 10, 20, 50, 100, -1],
    };
  },
  computed:{
    // table
    filteredCountries() {
      return this.countries.filter(country =>
        country.name.includes(this.searchQuery)
      );
    },
    paginatedCountries() {
      if (this.itemsPerPage === -1) {
        return this.filteredCountries;
      }
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredCountries.slice(start, end);
    },
    totalPages() {
      if (this.itemsPerPage === -1) {
        return 1;
      }
      return Math.ceil(this.filteredCountries.length / this.itemsPerPage);
    },

  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    changeItemsPerPage() {
      this.currentPage = 1;
    }
  },
  created(){},
};
</script>

<template>
  <div >
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="card con-all-tabel">
          <div class="card-body">
            <h4 class="card-title mb-3">احصائيات الدول</h4>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label for="search">بحث :</label>
                <input
                  id="search"
                  type="text"
                  v-model="searchQuery"
                  placeholder="ابحث عن دولة"
                  class="form-control mb-3"
                />
              </div>
              <div class="col-lg-4 col-md-12"></div>
              <div class="col-lg-4 col-md-12">
                <label for="itemsPerPage">عرض عدد الحقول :</label>
                <select
                  id="itemsPerPage"
                  class="form-select"
                  v-model="itemsPerPage"
                  @change="changeItemsPerPage"
                >
                  <option v-for="option in perPageOptions" :key="option" :value="option">
                    {{ option === -1 ? 'الكل' : option }}
                  </option>
                </select>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table mb-0 text-center">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>الدولة</th>
                    <th>العدد الكلي</th>
                    <th>عدد الذكور</th>
                    <th>عدد الاناث</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="paginatedCountries.length === 0">
                    <td colspan="5" class="text-center">لا توجد نتائج</td>
                  </tr>
                  <tr v-for="(country, index) in paginatedCountries" :key="country.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ country.name }}</td>
                  <td>{{ country.total }}</td>
                  <td>{{ country.males }}</td>
                  <td>{{ country.females }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <nav aria-label="Page navigation">
            <ul class="pagination justify-content-center mt-3">
              <li
                class="page-item"
                :class="{ disabled: currentPage === 1 }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage - 1)"
                >
                  السابق
                </a>
              </li>
              <li
                class="page-item"
                v-for="page in totalPages"
                :key="page"
                :class="{ active: currentPage === page }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(page)"
                >
                  {{ page }}
                </a>
              </li>
              <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage + 1)"
                >
                  التالي
                </a>
              </li>
            </ul>
          </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>